import localStorage from 'localStorage'

export default function setCurrentUser (user) {

	return localStorage.setItem('currentUser', JSON.stringify(user))

}
